<div class="container">
  <div class="close" (click)="closeDialog()">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <div class="steps">
    <app-step
      *ngIf="currentStep === STEPS.RELACION_DEPENDENCIA_CHOICE"
      [title]="'¿Trabajás en relación de dependencia?'"
    >
      <app-choice-component
        class="step-body"
        (responseSelected)="choiceResponse($event)"
      ></app-choice-component>
    </app-step>

    <app-step
      *ngIf="currentStep === STEPS.UPLOAD_ARBITRAGE_CERTIFICATION"
      (stepChanged)="stepChanged($event)"
      [enableNextButton]="enableNextButton"
      [nextButton]="true"
      [backButton]="true"
      [title]="'Documentación para arbitrar'"
    >
      <div class="step-body margin-top">
        <p class="label padding-bottom">
          Por favor, subí los documentos necesarios para poder subir tu límite:
        </p>
        <p class="instruction arbitraje">
          Certificacion contable.
          <span>Legalizada por el consejo profesional de ciencias económicas correspondiente.</span>
        </p>
        <app-reminder-message
          message="Si posee oblea digitalizada, tenés que enviar el archivo comprimido, tal como lo brindan luego de la legalización."
          type="warning"
        ></app-reminder-message>
        <app-upload-document
          (documentUploaded)="documentUploaded()"
          [uploadType]="UPLOAD_TYPE.ARBITRAGE_CERTIFICATION"
        ></app-upload-document>
      </div>
    </app-step>
    <app-step
      *ngIf="currentStep === STEPS.UPLOAD_ARBITRAGE_CEDULAR"
      (stepChanged)="stepChanged($event)"
      [enableNextButton]="enableNextButton"
      [nextButton]="true"
      [backButton]="true"
      [title]="'Documentación para arbitrar'"
    >
      <div class="step-body margin-top">
        <p class="label padding-bottom">
          Por favor, subí los documentos necesarios para poder subir tu límite:
        </p>
        <p class="instruction arbitraje">Alta del impuesto cedular</p>
        <app-reminder-message
          *ngIf="currentStep === STEPS.UPLOAD_ARBITRAGE_CEDULAR"
          message="Se debe enviar el documento de alta y no la presentacion del impuesto."
          type="warning"
        ></app-reminder-message>
        <app-upload-document
          (documentUploaded)="documentUploaded()"
          [uploadType]="UPLOAD_TYPE.ARBITRAGE_CEDULAR"
        ></app-upload-document>
      </div>
    </app-step>

    <app-step
      *ngIf="currentStep === STEPS.MONOTRIBUTO_CHOICE"
      (stepChanged)="stepChanged($event)"
      [backButton]="true"
      [title]="'¿Sos monotributista?'"
    >
      <app-choice-component
        class="step-body buttons-margin"
        (responseSelected)="choiceResponse($event)"
      ></app-choice-component>
    </app-step>

    <app-step
      *ngIf="
        currentStep === STEPS.UPLOAD_LAST_INCOMES ||
        currentStep === STEPS.UPLOAD_YEAR_INCOME ||
        currentStep === STEPS.UPLOAD_INCOME_DOC
      "
      (stepChanged)="stepChanged($event)"
      [enableNextButton]="enableNextButton"
      [nextButton]="true"
      [backButton]="true"
      [title]="'Origen de fondos'"
    >
      <div class="step-body">
        <p
          class="label"
          *ngIf="
            currentStep === STEPS.UPLOAD_LAST_INCOMES || currentStep === STEPS.UPLOAD_YEAR_INCOME
          "
        >
          Por favor, subí:
        </p>
        <p class="label padding-bottom" *ngIf="currentStep === STEPS.UPLOAD_INCOME_DOC">
          Por favor, subí documentos que justifiquen ingresos:
        </p>
        <p class="instruction" *ngIf="currentStep === STEPS.UPLOAD_LAST_INCOMES">
          Últimos tres recibos de sueldo.
        </p>
        <p class="instruction" *ngIf="currentStep === STEPS.UPLOAD_YEAR_INCOME">
          <span>1)</span> Tu constancia de opción.
        </p>
        <p class="instruction" *ngIf="currentStep === STEPS.UPLOAD_YEAR_INCOME">
          <span>2)</span> Tus últimos tres veps de pago o, tu facturación del ultimo año.
        </p>
        <p class="instruction" *ngIf="currentStep === STEPS.UPLOAD_INCOME_DOC">
          <span>Ejemplos:</span> Factura de una venta de auto, Factura de una venta de una casa,
          Donación, Herencia, etc.
        </p>
        <app-reminder-message
          *ngIf="currentStep === STEPS.UPLOAD_LAST_INCOMES"
          message="Si percibís tu salario de forma quincenal, <b>deberás enviar los últimos 6 recibos.</b>"
          type="warning"
        >
        </app-reminder-message>
        <app-reminder-message
          *ngIf="currentStep === STEPS.UPLOAD_YEAR_INCOME"
          message="De tratarse de esta ultima opción, te solicitamos que envíes todas las facturas en <b>un único documento.</b>"
          type="warning"
        >
        </app-reminder-message>
        <app-upload-document (documentUploaded)="documentUploaded()"></app-upload-document>
      </div>
    </app-step>

    <app-step
      [style.display]="currentStep === STEPS.FINAL_STEP_MESSAGE ? 'block' : 'none'"
      (stepChanged)="stepChanged($event)"
      [endButton]="true"
      [title]="'Esperá a ser validado'"
      [subtitle]="'Revisaremos la documentación'"
    >
      <img
        class="final-step"
        src="assets/images/waiting-doc-validation.svg"
        alt="Espera a ser validado"
      />
    </app-step>
  </div>
</div>
